import React from "react";
import submit from "submit-form";

export const PhaseRowHeader = ({ phases }) => {
  const openAddIndividualPhaseModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "add-individual-phase",
      },
    });
  };

  const openEditIndividualPhaseModal = (phase) => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "edit-individual-phase",
        phase,
      },
    });
  };

  return (
    <div className="phase-row-header">
      <span className="row-header-label phase-label">Phases</span>
      {phases && phases.length ? (
        phases.map((phase, index) => (
          <div
            className="phase-name-label"
            key={`phase-row-${index}`}
            onClick={() => openEditIndividualPhaseModal(phase)}
          >
            <span className="row-header">{phase.phaseName}</span>
            <div
              className="phase-color-dot"
              style={{ backgroundColor: phase.phaseColor }}
            />
          </div>
        ))
      ) : (
        <div
          className="phase-name-label add-phase"
          onClick={openAddIndividualPhaseModal}
        >
          <span className="row-header">Add Phase</span>
        </div>
      )}
      <div
        role="button"
        data-button-type="primary"
        className="add-phase-button"
        onClick={openAddIndividualPhaseModal}
      >
        <img src="/img/new-icons/add.svg" className="add-phase-icon" />
      </div>
    </div>
  );
};
